import axios from "axios"

export const getBrandApi = (payload) => {
	const prodUrl = process.env.REACT_APP_BASE_URL
	return axios
		.get(prodUrl + `inventory-service/api/v1/${payload}`)
		.then(function (response) {
			return response
		})
		.catch((error) => {
			return error
		})
}
